import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Ruta {
  id?: number;
  nombre: string;
  ruta: string;
  origen: string;
  destino: string;
  estado: string;
}

@Injectable({
  providedIn: 'root'
})
export class RutasService {
  private apiUrl = `${environment.apiUrl}/api/rutas`;

  constructor(private http: HttpClient) {}

  getRutas(): Observable<Ruta[]> {
    return this.http.get<Ruta[]>(this.apiUrl, { withCredentials: true });
  }

  getRutaById(id: number): Observable<Ruta> {
    return this.http.get<Ruta>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  createRuta(ruta: Ruta): Observable<Ruta> {
    return this.http.post<Ruta>(this.apiUrl, ruta, { withCredentials: true });
  }

  updateRuta(id: number, ruta: Ruta): Observable<Ruta> {
    return this.http.put<Ruta>(`${this.apiUrl}/${id}`, ruta, { withCredentials: true });
  }

  inactivarRuta(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, { estado: 0 }, { withCredentials: true });
  }

  getRutasInactivas(): Observable<Ruta[]> {
    return this.http.get<Ruta[]>(`${this.apiUrl}/inactivas`, { withCredentials: true });
  }

  activarRuta(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/activar/${id}`, { estado: 0 }, { withCredentials: true });
  }
}
